<template>
  <dialog-base
    :visible.sync="visible"
    title="Hướng dẫn thao tác khoản thu chính"
    size="lg"
    cancel-text="Đóng"
    confirm-text="Đã hiểu"
    :use-panel="false"
    :append-to-body="true"
    top="6vh"
    @confirm="handleClose"
    @cancel="handleClose"
  >
    <div class="trg-guide">
      <div class="trg-section">
        <p class="trg-title">1) Thông tin chung</p>
        <ul>
          <li>Nhập <strong>Tên khoản thu</strong>, chọn <strong>Loại khoản</strong> và <strong>Đơn vị tính</strong>.</li>
          <li>Mục <strong>Mô tả</strong> dùng để ghi chú ngắn giúp dễ nhận diện khi quản lý.</li>
        </ul>
      </div>

      <div class="trg-section">
        <p class="trg-title">2) Tài chính và công thức</p>
        <p class="trg-subtitle">Trường hợp không áp dụng công thức</p>
        <ul>
          <li>Chọn <strong>Không</strong> tại mục <strong>Áp dụng công thức</strong>.</li>
          <li>Nhập <strong>Đơn giá</strong> và <strong>Số lượng</strong>.</li>
          <li>Nếu cần, bật <strong>Giảm giá</strong> và chọn kiểu giảm phù hợp.</li>
        </ul>
        <p class="trg-example">Ví dụ: Đơn giá 2.000.000, số lượng 1, giảm 10% - thành tiền tham khảo còn 1.800.000.</p>

        <p class="trg-subtitle">Trường hợp áp dụng công thức</p>
        <ul>
          <li>Chọn <strong>Có</strong> tại mục <strong>Áp dụng công thức</strong>.</li>
          <li>Nhấn <strong>Thêm biến</strong> để khai báo biến từ A-Z và chọn khoản thu gốc tương ứng.</li>
          <li>Nhập biểu thức chỉ dùng các biến đã khai báo.</li>
          <li>Chỉ dùng các phép toán <strong>+</strong>, <strong>-</strong>, <strong>*</strong>, <strong>/</strong> và ngoặc <strong>()</strong>.</li>
        </ul>
        <p class="trg-example">Ví dụ: A = Học phí, B = Tiền ăn, biểu thức <strong>(A + B) * 0.9</strong> là giảm 10% trên tổng A và B.</p>
      </div>

      <div class="trg-section">
        <p class="trg-title">3) Thuế và hóa đơn điện tử</p>
        <ul>
          <li>Nếu bật <strong>Hóa đơn điện tử</strong>, hệ thống sẽ tự yêu cầu bật <strong>Khai báo thuế</strong>.</li>
          <li>Khi chọn thuế <strong>Khác</strong>, cần nhập thêm phần trăm tại ô <strong>Thuế khác (%)</strong>.</li>
        </ul>
      </div>

      <div class="trg-section">
        <p class="trg-title">4) Thời gian áp dụng</p>
        <ul>
          <li><strong>Theo tháng</strong>: chọn các tháng áp dụng, sau đó chọn cả tháng hoặc tùy chỉnh ngày.</li>
          <li><strong>Theo khoảng ngày</strong>: chọn ngày bắt đầu và kết thúc.</li>
<!--          <li><strong>Số đơn vị</strong>: nhập giới hạn đơn vị áp dụng (nếu nghiệp vụ cần).</li>-->
        </ul>
      </div>

      <div class="trg-section">
        <p class="trg-title">5) Cấu hình điểm danh</p>
        <ul>
          <li>Bật <strong>Áp dụng điểm danh</strong> để chọn phương pháp tính, loại điểm danh và chi tiết tương ứng.</li>
          <li>Với trường hợp <strong>Đón muộn</strong>, cần nhập giờ đón về và cấu hình các khoảng thời gian tính phí.</li>
        </ul>
      </div>

      <div class="trg-note">Mẹo: Bạn vẫn có thể rê chuột vào từng biểu tượng dấu hỏi cạnh để xem giải thích nhanh tại chỗ.</div>
    </div>
  </dialog-base>
</template>

<script>
import DialogBase from "@/components/DialogBase.vue";

export default {
  name: "TotalRevenueGuideDialog",
  components: { DialogBase },
  data() {
    return {
      visible: false,
    };
  },
  methods: {
    open() {
      this.visible = true;
    },
    handleClose() {
      this.visible = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.trg-guide {
  max-height: 72vh;
  overflow: auto;
  padding-right: 4px;
}

.trg-section + .trg-section {
  margin-top: 10px;
  padding-top: 10px;
  border-top: 1px dashed #e2e8f0;
}

.trg-title {
  margin: 0 0 6px;
  font-size: 14px;
  font-weight: 700;
  color: #0f172a;
}

.trg-subtitle {
  margin: 8px 0 4px;
  font-size: 13px;
  font-weight: 700;
  color: #1e293b;
}

ul {
  margin: 0 0 4px 16px;
  padding: 0;
  color: #334155;
  line-height: 1.5;
}

.trg-example {
  margin: 0;
  color: #0f766e;
  font-size: 12px;
  font-style: italic;
}

.trg-note {
  margin-top: 12px;
  padding: 8px 10px;
  border-radius: 8px;
  border: 1px solid #bfdbfe;
  background: #eff6ff;
  color: #1d4ed8;
  font-size: 12px;
}
</style>

